module.exports = __webpack_public_path__ + "img/ec.0775eb34.svg";